import { NavLink, Outlet } from "react-router";

const NAV_LINKS = [
    { to: "/settings/gmail-oauth", label: "Gmail OAuth" },
    { to: "/settings/tone-profiles", label: "Tone Profiles" },
    { to: "/settings/categories", label: "Categories" },
    { to: "/settings/addon", label: "Gmail Add-on" },
    { to: "/settings/company", label: "Company" },
    { to: "/settings/team", label: "Team" },
    { to: "/settings/privacy", label: "Privacy & Data" },
] as const;

export function SettingsLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <nav className="border-b bg-card px-6 py-3" aria-label="Settings navigation">
                <div className="flex items-center gap-1">
                    {NAV_LINKS.map(({ to, label }) => (
                        <NavLink
                            key={to}
                            to={to}
                            className={({ isActive }) =>
                                `px-3 py-1.5 rounded text-sm font-medium transition-colors ${
                                    isActive
                                        ? "bg-primary text-primary-foreground"
                                        : "text-muted-foreground hover:text-foreground hover:bg-muted"
                                }`
                            }
                        >
                            {label}
                        </NavLink>
                    ))}
                </div>
            </nav>
            <Outlet />
        </div>
    );
}
